import { Kind, visit } from "graphql";
import { mapDefinition, findDefinition, findNodeAtPath, removeField, addField } from "./ast-path.js";
function collectVariableReferences(selectionSet, into) {
  visit(selectionSet, {
    Variable(node) {
      into.add(node.name.value);
    }
  });
}
function pruneUnusedVariableDefinitions(operation, doc) {
  const varDefs = operation.variableDefinitions;
  if (!varDefs) {
    return operation;
  }
  const used = /* @__PURE__ */ new Set();
  collectVariableReferences(operation.selectionSet, used);
  for (const def of doc.definitions) {
    if (def.kind === Kind.FRAGMENT_DEFINITION) {
      collectVariableReferences(def.selectionSet, used);
    }
  }
  const kept = varDefs.filter((vd) => used.has(vd.variable.name.value));
  if (kept.length === varDefs.length) {
    return operation;
  }
  return {
    ...operation,
    variableDefinitions: kept
  };
}
function isFieldSelected(doc, path, target) {
  if (path.length === 0) {
    return false;
  }
  const definition = findDefinition(doc, target);
  if (!definition) {
    return false;
  }
  return findNodeAtPath(definition.selectionSet, path) !== void 0;
}
function toggleFieldSelection(doc, path, target) {
  if (path.length === 0) {
    return doc;
  }
  const selected = isFieldSelected(doc, path, target);
  return mapDefinition(doc, target, (definition) => {
    const newSelectionSet = selected ? removeField(definition.selectionSet, path) : addField(definition.selectionSet, path);
    if (newSelectionSet.selections.length === 0) {
      if (definition.kind === Kind.OPERATION_DEFINITION) {
        return null;
      }
      return definition;
    }
    if (definition.kind === Kind.FRAGMENT_DEFINITION) {
      return {
        ...definition,
        selectionSet: newSelectionSet
      };
    }
    let newOperation = {
      ...definition,
      selectionSet: newSelectionSet
    };
    if (selected) {
      newOperation = pruneUnusedVariableDefinitions(newOperation, doc);
    }
    return newOperation;
  });
}
export {
  collectVariableReferences,
  isFieldSelected,
  pruneUnusedVariableDefinitions,
  toggleFieldSelection
};
//# sourceMappingURL=field-selection.js.map
